import styled from 'styled-components';
import ImageAdd from 'images/icon/image_add.svg';
import ImageEdit from 'images/icon/image_edit.svg';
import { OnPrimaryColor, PrimaryColor, SidelyBlack, SurfaceColor } from '../../../styles/global/css/Utils';

const Container = styled.label<{ size?: number }>`
    display: block;
    width: ${p => p.size ?? 50}px;
    height: ${p => p.size ?? 50}px;
    margin: 0;
    position: relative;
    flex-shrink: 0;
    cursor: pointer;
    border-radius: 50%;
`;

const FileInput = styled.input`
    position: absolute;
    inset: -8px;
    margin: 0;
    opacity: 0;
    cursor: pointer;
`;

const Icon = styled.div<{ url: string, color: string }>`
    width: 55%;
    height: 55%;
    background-color: ${p => p.color};
    -webkit-mask: url('${p => p.url}') center / contain no-repeat;
    mask: url('${p => p.url}') center / contain no-repeat;
`;

const AddBlock = styled.div<{ noBackground?: boolean, backoungroundColor?: string, hasImage?: boolean }>`
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;s
    pointer-events: none;
    cursor: pointer;
    transition: border-color 0.2s ease, background-color 0.2s ease;
    ${p => p.hasImage || p.noBackground
		? `border: 1px solid transparent; background-color: ${SurfaceColor};`
		: `border: 1.5px dashed ${p.backoungroundColor ?? PrimaryColor};
    background-color: color-mix(in oklab, ${p.backoungroundColor ?? PrimaryColor} 8%, ${SurfaceColor});`}

    ${Container}:hover > &, ${FileInput}:focus-visible + & {
        border-style: solid;
        border-color: ${p => p.backoungroundColor ?? PrimaryColor};
        ${p => p.hasImage ? '' : `background-color: color-mix(in oklab, ${p.backoungroundColor ?? PrimaryColor} 14%, ${SurfaceColor});`}
    }
`;

const AddBlockFolder = styled.div<{ backgroundColor?: string }>`
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border-radius: 50%;
    border: 1.5px dashed ${p => p.backgroundColor ?? PrimaryColor};
    background-color: color-mix(in oklab, ${p => p.backgroundColor ?? PrimaryColor} 8%, ${SurfaceColor});
    position: relative;
    transition: background-color 0.2s ease;

    &::after {
        content: '';
        position: absolute;
        inset: 25%;
        background-color: ${p => p.backgroundColor ?? PrimaryColor};
        -webkit-mask: url('${ImageAdd}') center / contain no-repeat;
        mask: url('${ImageAdd}') center / contain no-repeat;
    }

    &:hover {
        border-style: solid;
        background-color: color-mix(in oklab, ${p => p.backgroundColor ?? PrimaryColor} 14%, ${SurfaceColor});
    }
`;

const AddImage = styled.div<{ src: string }>`
    width: 100%;
    height: 100%;
    position: relative;
    cursor: pointer;
    border-radius: 50%;
    background-image: url('${p => p.src}');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    &::before, &::after {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 50%;
        opacity: 0;
        transition: opacity 0.2s ease;
    }

    &::before {
        background-color: color-mix(in oklab, ${SidelyBlack} 45%, transparent);
    }

    &::after {
        inset: 28%;
        background-color: ${OnPrimaryColor};
        -webkit-mask: url('${ImageEdit}') center / contain no-repeat;
        mask: url('${ImageEdit}') center / contain no-repeat;
    }

    ${Container}:hover &::before, ${Container}:hover &::after,
    ${FileInput}:focus-visible ~ * &::before, ${FileInput}:focus-visible ~ * &::after {
        opacity: 1;
    }
`;

export {
	Container,
	FileInput,
	Icon,
	AddBlock,
	AddImage,
	AddBlockFolder,
	ImageAdd
};
